import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const cartItems = [
  {
    id: 1,
    name: "Soft Hoodie",
    price: 250000,
    size: "S",
    image: "https://app.thesoyara.com/uploads/5/83067.jpeg",
    checked: true,
  },
  {
    id: 2,
    name: "Leather Bag",
    price: 150000,
    size: "S",
    image: "https://app.thesoyara.com/uploads/63/39245.jpeg",
    checked: false,
  },
  {
    id: 3,
    name: "Sunglass",
    price: 399000,
    size: "S",
    image: "https://app.thesoyara.com/uploads/44/99834.jpeg",
    checked: false,
  },
];

export default function AddToCart() {
  const [items, setItems] = React.useState(cartItems);
  const [age, setAge] = React.useState("");
  const [value, setValue] = React.useState(null);

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const cardVariants = {
    initial: { scale: 1 },
    hover: {
      scale: 1.01,
      boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
      transition: {
        duration: 0.4,
        // delay: 0.3,
        ease: "linear",
      },
    },
  };

  return (
    <Grid container spacing={4} className="add-to-cart-container">
      <Grid size={{ lg: 8, md: 8, xs: 12, sm: 12 }}>
        {items.map((item) => (
          <motion.div
            key={item.id}
            variants={cardVariants}
            initial="initial"
            whileHover="hover"
            className="cart-item-block"
          >
            <img src={item.image} alt={item.name} className="cart-img" />
            <Box sx={{ ml: 2 }}>
              <Typography>{item.name}</Typography>
              <Typography sx={{ color: "gray" }}>
                Rp {item.price.toLocaleString()}
              </Typography>
              <Typography variant="caption">Size: {item.size}</Typography>
            </Box>
            <Box sx={{ ml: "auto" }}>
              <IconButton>
                <FontAwesomeIcon icon={faTrash} />
              </IconButton>
            </Box>
          </motion.div>
        ))}
      </Grid>

      <Grid size={{ lg: 4, md: 4, xs: 12, sm: 12 }}>
        <Card elevation={3} sx={{ borderRadius: 4 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Summary
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
              Do you have a promotional code?
            </Typography>
            <Box sx={{ mb: 2 }}>
              <TextField
                id="outlined-basic"
                size="small"
                fullWidth
                label="Enter Full Name"
                variant="outlined"
                style={{ marginBottom: "20px" }}
              />

              <TextField
                id="outlined-basic"
                size="small"
                fullWidth
                label="Enter Mobile No."
                variant="outlined"
                style={{ marginBottom: "20px" }}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Age</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Age"
                  onChange={handleChange}
                  fullWidth
                  size="small"
                >
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>
              {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Select Date"
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider> */}
            </Box>
            <Button variant="contained" fullWidth>
              Checkout
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
